import {
  Empty,
  EmptyDescription,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle,
} from "@/components/ui/empty"
import { ReactElement, ReactNode } from "react"

const RAEmpty = ({
  source,
  mode,
  icon,
}: {
  source: string
  mode: string
  icon: ReactElement | ReactNode
}) => {
  return (
    <Empty>
      <EmptyHeader>
        <EmptyMedia variant="icon">{icon}</EmptyMedia>
        <EmptyTitle>No {source} Yet</EmptyTitle>
        {mode === "edit" && (
          <EmptyDescription>
            You haven&apos;t created any {source} yet. Get started by creating
            your first one.
          </EmptyDescription>
        )}
      </EmptyHeader>
      {/* <EmptyContent>
        <div className="flex gap-2">
          <Button>Create Item</Button>
        </div>
      </EmptyContent> */}
    </Empty>
  )
}

export default RAEmpty
